<mat-toolbar color="accent">
  <h1>Parchment Integration</h1>
</mat-toolbar>

<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content>
    <div class="flex flex-col">
      <mat-form-field>
        <mat-label>Organisation Id</mat-label>
        <input matInput formControlName="organisationId" autofocus />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Organisation Secret</mat-label>
        <input type="password" matInput formControlName="organisationSecret" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>User Id</mat-label>
        <input matInput formControlName="userId" />
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <pt-buttons-container padding="none">
      <button mat-stroked-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" [disabled]="form.invalid">
        Submit
      </button>
    </pt-buttons-container>
  </mat-dialog-actions>
</form>
